import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
    errorIndexedDB: boolean,
    onClose(...args: any): void
}

export default function ErrorIndexedDBDialog({errorIndexedDB, onClose}: Props) {
    const {t} = useTranslation();

    return (
        <Dialog
            open={errorIndexedDB}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("indexedDB_error")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={onClose}>{t('Close')}</Button>
            </DialogActions>
        </Dialog>
    )
}